export { unstable_generateUtilityClasses as default } from '@mui/utils';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/generateUtilityClasses/index.js
// module id = 1859
// module chunks = 22